module.exports = __webpack_public_path__ + "static/media/Mountain1M.822d81d5.gif";